import { lazy } from 'react';

export const LinkTelegram = lazy(() => import('./LinkTelegram.component'));
